import { keyframes, css } from 'styled-components';

const fadeIn = keyframes`
    from {
        opacity: 0;
        transform: translateY(12px); /* Subtle slide up */
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
`;

// A reusable animation helper
export const animateIn = (delay = '0s') => css`
	opacity: 0; /* Starts hidden to prevent a flash */
	animation: ${fadeIn} 0.5s ease-in-out forwards;
	animation-delay: ${delay};
`;
